import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useI18n, useLocalizedPath } from "../i18n/I18nContext";
import { api } from "../lib/api";

export default function Blog() {
  const { t, lang } = useI18n();
  const lp = useLocalizedPath();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then(({ data }) => {
      setPosts(data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="container mx-auto px-6 py-12 md:py-20 max-w-5xl">
      <div className="max-w-2xl mb-16">
        <p className="font-mono-label text-gold/80 mb-4">
          {lang === "en" ? "Journal · Field notes" : "Jurnal · Note de teren"}
        </p>
        <h1 className="font-display text-4xl md:text-6xl tracking-tighter">{t.blog.title}</h1>
        <p className="mt-6 text-white/55 text-lg">{t.blog.sub}</p>
      </div>

      {loading ? (
        <div className="text-white/40 font-mono-label">{t.common.loading}</div>
      ) : (
        <div className="space-y-6">
          {posts.map((p, i) => {
            const tr = p.translations[lang];
            return (
              <motion.div
                key={p.slug}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
              >
                <Link
                  to={lp(`/blog/${p.slug}`)}
                  className="glass glass-hover rounded-2xl p-8 md:p-10 block group"
                >
                  <div className="flex items-center gap-3 mb-5 font-mono-label text-white/40">
                    <span>{p.category}</span>
                    <span>·</span>
                    <span>{p.read_time_min} min</span>
                  </div>
                  <h2 className="font-display text-2xl md:text-4xl tracking-tighter">{tr.title}</h2>
                  <p className="mt-4 text-white/60 max-w-2xl">{tr.excerpt}</p>
                  <div className="mt-6 inline-flex items-center gap-2 text-sm font-mono-label text-white/40 group-hover:text-gold transition-colors">
                    {t.blog.readMore} <ArrowUpRight className="h-3.5 w-3.5" />
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      )}
    </div>
  );
}
